import { Directive } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  UntypedFormGroup,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

@Directive()
export abstract class EaProfilEmprunteurBuilder extends PrFormAbstract {
  generate(entity, option) {
    let options: AbstractControlOptions = {};
    return this.formBuilder.group(
      {
        profilEmprunteurs: this.formBuilder.array(
          this.buildProfilEmprunteurs(entity?.profilEmprunteurs || []),
          options,
        ),
        optimizationId: [entity?.optimizationId || null],
        accountId: [entity?.accountId || null],
      },
      options,
    );
  }

  private buildProfilEmprunteurs(profilEmprunteurs: any[]): UntypedFormGroup[] {
    return profilEmprunteurs.map(profilEmprunteur =>
      this.formBuilder.group({
        ownerId: [profilEmprunteur.ownerId || null],
        accountId: [profilEmprunteur.accountId || null],
        fumeur: [profilEmprunteur.fumeur || false],
        vapoteur: [profilEmprunteur.vapoteur || false],
        vapoteurSansNicotine: [profilEmprunteur.vapoteurSansNicotine || false],
        deplacementKilometrique: [
          profilEmprunteur.deplacementKilometrique || 'AUCUN',
        ],
        travailEnHauteur: [profilEmprunteur.travailEnHauteur || 'AUCUN'],
        travailManuel: [profilEmprunteur.travailManuel || false],
        travailManuelAvecOutillage: [
          profilEmprunteur.travailManuelAvecOutillage || false,
        ],
        travailARisque: [
          profilEmprunteur.travailARisque ||
            'OCCUPATION_ATRISK_AUCUNE_PROF_A_RISQUE',
        ],
        travailProduitsDangereux: [
          profilEmprunteur.travailProduitsDangereux || false,
        ],
        travailDebout: [profilEmprunteur.travailDebout || false],
        sportARisque: [profilEmprunteur.sportARisque || false],
        deplacementsProfessionnelsOuHumanitairesEtranger: [
          profilEmprunteur.deplacementsProfessionnelsOuHumanitairesEtranger ||
            false,
        ],
        optionIPP: [profilEmprunteur.optionIPP || false],
        optionDosPsy: [profilEmprunteur.optionDosPsy || false],
        loiLemoine: [profilEmprunteur.loiLemoine || false],
      }),
    );
  }

  get profilEmprunteurs() {
    return this.form.get('profilEmprunteurs') as UntypedFormArray;
  }

  extract() {
    return {
      profilEmprunteurs: this.form.value.profilEmprunteurs,
      optimizationId: this.form.value.optimizationId,
      accountId: this.form.value.accountId,
    };
  }
}
